// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-scorer__container {
    margin-top: calc( var( --space-x2 ) + var( --space-eighth ) );
}

.league-match-scorer__container__teams {
    width: 100%;
}

.league-match-scorer_column-title{
    margin-left: var(--space-x2);
    margin-bottom: var(--space);
}

.league-match-scorer__score.baloa-headline-2 {
    color: var( --primary-dark-color );
    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);
}

.league-match-scorer__contianer__info-team-player {
    display: flex;
    justify-content: space-between;
    margin: 0 var( --space-and-half );
    gap: var(--space-and-half)
}

.league-match-scorer__contianer__info-player{
    overflow: scroll;
    height: 437px;
    background: var(--new-background-color);
    border-radius: 8px;
}

.league-match-scorer__contianer__empty-message {
    display: grid;
    align-items: center;
    justify-items: center;
    width: 100%;
    height: 100%;
}

.league-match-scorer__contianer__empty-message.baloa-table{
    font-weight: var(--font-medium);
    color: var(--basic-gray-color);
}

.league-match-scorer__cointainer__scorer_input {
    margin: var(--space-half);
    background: var(--white-color);
    padding: var(--space);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.league-match-scorer__cointainer__scorer_input:last-of-type {
    margin-bottom: 0;
    padding-bottom: var(--space);
    border-bottom: none;
}

.league-match-scorer_column_score-team{
    margin-right: var(--space);
}
.league-match-scorer_column_score-team.baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.league-match-scorer__cointainer__scorer_radio-buttons{
    margin-bottom: var(--space-and-half);
}

.league-match-scorer__cointainer__scorer__option-button .MuiFormControlLabel-root{
    border: solid 1px var(--new-gray-background-color);
    border-radius: 9px;
    padding: 3px 5px;
    height: 40px;
    margin: 0px;
    width: 100%;
}

.league-match-scorer__cointainer__scorer_radio-buttons .MuiFormControl-root.league-match-scorer__cointainer__scorer_actions_content__button{
    width: 100%;
}

.league-match-scorer__cointainer__scorer_radio-buttons .MuiFormGroup-root{
    gap: 20px;
    flex-wrap: nowrap;
}

.league-match-scorer__cointainer__scorer__option-button .MuiFormControlLabel-root.selected{
    border: solid 1px var(--basic-green-color);
}

.league-match-scorer__cointainer__info-players__column {
    width: 100%;
}

.league-match-scorer__cointainer__info-players__column:first-of-type {
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
}

.league-match-scorer_column_inf-team_photo {
    width: 50px;
    border-radius: 50%;
}


.league-match-scorer_column_inf-team .icon-ball{
    color: var(--white-color );
    font-size: 47px;
    border-radius: 50%;
    padding: 3px;
}

.league-match-scorer_container_column_inf-team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding-bottom: var(--space);
}

.league-match-scorer__cointainer__scorer_input .MuiAutocomplete-root .MuiFormLabel-root.MuiInputLabel-root{
    font-weight: 400;
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.league-match-scorer-input_field_autcomplete{
    position: relative;
    width: 100%;
}

.league-match-scorer_column_inf-team{
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: var(--space);
}

.league-match-scorer__cointainer__info-players__column:last-of-type {
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
}

.league-match-scorer__assigner_minute {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: var(--space);
    margin: 12px 0;
}

.league-match-scorer__assigner_minute .MuiAutocomplete-root {
    width: 100%;
}

.league-match-scorer__input-container .minute-input .form-minute-input div{
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.league-match-scorer__input-container .minute-input .form-minute-input label.MuiInputLabel-outlined.MuiInputLabel-shrink{
    font-weight: 400;
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

/* .league-match-scorer__check div:first-of-type {
    margin-right: var( --space );
} */

.league-match-scorer__own-goal__container {
    display: flex;
    align-items: center;
    margin-bottom: var(--space);
}

.league-match-scorer__label.baloa-normal {
    font-size: calc( var( --space ) + 1px );
    color: var( --basic-gray-color );
}


.league-match-scorer__own-goal__container .MuiCheckbox-root {
    color: var( --new-green-color );
}

.league-match-scorer__own-goal__container .baloa-names {
    color: var( --basic-gray-color );
} 


`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-scorer/LeagueMatchScorerComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;AACjE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,+DAA+D;AACnE;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;IACrB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;IACzD,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qCAAqC;AACzC;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC;;;AAGA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".league-match-scorer__container {\n    margin-top: calc( var( --space-x2 ) + var( --space-eighth ) );\n}\n\n.league-match-scorer__container__teams {\n    width: 100%;\n}\n\n.league-match-scorer_column-title{\n    margin-left: var(--space-x2);\n    margin-bottom: var(--space);\n}\n\n.league-match-scorer__score.baloa-headline-2 {\n    color: var( --primary-dark-color );\n    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);\n}\n\n.league-match-scorer__contianer__info-team-player {\n    display: flex;\n    justify-content: space-between;\n    margin: 0 var( --space-and-half );\n    gap: var(--space-and-half)\n}\n\n.league-match-scorer__contianer__info-player{\n    overflow: scroll;\n    height: 437px;\n    background: var(--new-background-color);\n    border-radius: 8px;\n}\n\n.league-match-scorer__contianer__empty-message {\n    display: grid;\n    align-items: center;\n    justify-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.league-match-scorer__contianer__empty-message.baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--basic-gray-color);\n}\n\n.league-match-scorer__cointainer__scorer_input {\n    margin: var(--space-half);\n    background: var(--white-color);\n    padding: var(--space);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.league-match-scorer__cointainer__scorer_input:last-of-type {\n    margin-bottom: 0;\n    padding-bottom: var(--space);\n    border-bottom: none;\n}\n\n.league-match-scorer_column_score-team{\n    margin-right: var(--space);\n}\n.league-match-scorer_column_score-team.baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-scorer__cointainer__scorer_radio-buttons{\n    margin-bottom: var(--space-and-half);\n}\n\n.league-match-scorer__cointainer__scorer__option-button .MuiFormControlLabel-root{\n    border: solid 1px var(--new-gray-background-color);\n    border-radius: 9px;\n    padding: 3px 5px;\n    height: 40px;\n    margin: 0px;\n    width: 100%;\n}\n\n.league-match-scorer__cointainer__scorer_radio-buttons .MuiFormControl-root.league-match-scorer__cointainer__scorer_actions_content__button{\n    width: 100%;\n}\n\n.league-match-scorer__cointainer__scorer_radio-buttons .MuiFormGroup-root{\n    gap: 20px;\n    flex-wrap: nowrap;\n}\n\n.league-match-scorer__cointainer__scorer__option-button .MuiFormControlLabel-root.selected{\n    border: solid 1px var(--basic-green-color);\n}\n\n.league-match-scorer__cointainer__info-players__column {\n    width: 100%;\n}\n\n.league-match-scorer__cointainer__info-players__column:first-of-type {\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n}\n\n.league-match-scorer_column_inf-team_photo {\n    width: 50px;\n    border-radius: 50%;\n}\n\n\n.league-match-scorer_column_inf-team .icon-ball{\n    color: var(--white-color );\n    font-size: 47px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league-match-scorer_container_column_inf-team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding-bottom: var(--space);\n}\n\n.league-match-scorer__cointainer__scorer_input .MuiAutocomplete-root .MuiFormLabel-root.MuiInputLabel-root{\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.league-match-scorer-input_field_autcomplete{\n    position: relative;\n    width: 100%;\n}\n\n.league-match-scorer_column_inf-team{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: var(--space);\n}\n\n.league-match-scorer__cointainer__info-players__column:last-of-type {\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n}\n\n.league-match-scorer__assigner_minute {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: var(--space);\n    margin: 12px 0;\n}\n\n.league-match-scorer__assigner_minute .MuiAutocomplete-root {\n    width: 100%;\n}\n\n.league-match-scorer__input-container .minute-input .form-minute-input div{\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.league-match-scorer__input-container .minute-input .form-minute-input label.MuiInputLabel-outlined.MuiInputLabel-shrink{\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n/* .league-match-scorer__check div:first-of-type {\n    margin-right: var( --space );\n} */\n\n.league-match-scorer__own-goal__container {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space);\n}\n\n.league-match-scorer__label.baloa-normal {\n    font-size: calc( var( --space ) + 1px );\n    color: var( --basic-gray-color );\n}\n\n\n.league-match-scorer__own-goal__container .MuiCheckbox-root {\n    color: var( --new-green-color );\n}\n\n.league-match-scorer__own-goal__container .baloa-names {\n    color: var( --basic-gray-color );\n} \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
